import { useDisclosure } from "@chakra-ui/hooks";
import React from "react";
import ConnectionModal from "./ConnectionModal";
/**
 * Button component to open the Connection Modal
 */
var ModalButton = function (_a) {
    var connectMetamask = _a.connectMetamask, connectWalletConnect = _a.connectWalletConnect, connectTorus = _a.connectTorus, buttonContent = _a.buttonContent;
    var _b = useDisclosure(), isOpen = _b.isOpen, onOpen = _b.onOpen, onClose = _b.onClose;
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "ProductForm__AddToCart Button Button--primary Button--full", id: "modalButton", style: { margin: "10px auto" }, onClick: function () {
                onOpen();
            } }, buttonContent),
        React.createElement(ConnectionModal, { isOpen: isOpen, onClose: onClose, connectMetamask: connectMetamask, connectWalletConnect: connectWalletConnect, connectTorus: connectTorus })));
};
export default ModalButton;
